import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Typography } from '@mui/material';
import useApiContext from 'hooks/useApiContext';
import routes from 'router/routes';
import { iEventSummary } from 'services/Ticketing/Ticketing.type';
import { card, PAGE_SX, formatDay, sectionTitle } from './common';

/** Events with ticketing that the user may scan (admins and moderators). */
export default function ScanIndex(): JSX.Element {
  const { ticketingRepository } = useApiContext();
  const navigate = useNavigate();
  const [events, setEvents] = useState<iEventSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    ticketingRepository
      .getScanEvents()
      .then((r) => setEvents(r.events))
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <Box sx={{ ...PAGE_SX, maxWidth: 900 }}>
      <Box sx={{ fontSize: '22px', fontWeight: 700, color: '#111' }}>
        Scan des billets
      </Box>
      <Typography sx={{ fontSize: '13px', color: '#888', mt: 0.5, mb: 3 }}>
        Choisissez le salon, puis scannez les QR codes avec la caméra du
        téléphone ou de la tablette.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {events && events.length === 0 && (
        <Box sx={card}>
          Aucun salon en cours ou à venir avec la billetterie activée.
        </Box>
      )}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2,
        }}
      >
        {(events ?? []).map((e) => (
          <Box
            key={e.id}
            role="button"
            tabIndex={0}
            onClick={() => navigate(`${routes.home2.path}scan/${e.id}`)}
            onKeyDown={(k) =>
              k.key === 'Enter' && navigate(`${routes.home2.path}scan/${e.id}`)
            }
            sx={{
              ...card,
              cursor: 'pointer',
              transition: 'box-shadow 0.15s',
              '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
            }}
          >
            <Typography sx={sectionTitle}>{e.name}</Typography>
            <Typography sx={{ fontSize: '13px', color: '#888', mt: 0.5 }}>
              {formatDay(e.date)}
              {e.date_of_the_end && e.date_of_the_end !== e.date
                ? ` – ${formatDay(e.date_of_the_end)}`
                : ''}
              {e.city ? ` · ${e.city}` : ''}
            </Typography>
            <Typography
              sx={{ fontSize: '13px', fontWeight: 600, color: '#111', mt: 1.5 }}
            >
              {e.tickets} billet(s) · Ouvrir le scanner →
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
